import type { AxiosInstance } from 'axios';
import { Platform } from 'react-native';
import { getMessaging, getAPNSToken, getToken } from '@react-native-firebase/messaging';
import { log, recordError } from 'app/lib/monitoring';
import { CustomerIO } from 'customerio-reactnative';
import { isMobileNative } from 'app/utils/web-helpers';

export const pushNotifRegistrationInstance = (http: AxiosInstance) => {
  return new (class {
    public unregisterFromRemoteNotifications = async () => {
      if (!isMobileNative) return;
      try {
        const messaging = getMessaging();
        const token = Platform.OS === 'ios' ? await getAPNSToken(messaging) : await getToken(messaging);

        if (!token) {
          log('No push token available; skipping unregistration');
          return;
        }

        log(`Un-registered for remote notifications using platform-dependent token: ${token}`);

        // Usage of "messaging().unregisterDeviceForRemoteMessages()" is not required. You only need to register if auto-registration is disabled in your 'firebase.json' configuration file via the 'messaging_ios_auto_register_for_remote_messages' property.
        // await messaging().unregisterDeviceForRemoteMessages();

        void CustomerIO.deleteDeviceToken();

        void http.post('/notifications/unregister', { token });
      } catch (err) {
        recordError(err);
      }
    };

    public registerForRemoteNotifications = async () => {
      if (!isMobileNative) return;
      try {
        const messaging = getMessaging();
        const token = Platform.OS === 'ios' ? await getAPNSToken(messaging) : await getToken(messaging);

        if (!token) {
          log('No push token available; skipping registration');
          return;
        }

        log(`Registered for remote notifications using platform-dependent token: ${token}`);

        // Usage of "messaging().registerDeviceForRemoteMessages()" is not required. You only need to register if auto-registration is disabled in your 'firebase.json' configuration file via the 'messaging_ios_auto_register_for_remote_messages' property.
        // await messaging().registerDeviceForRemoteMessages();

        void CustomerIO.registerDeviceToken(token);

        void http.post('/notifications/register', {
          token,
        });
      } catch (err) {
        recordError(err);
      }
    };
  })();
};
